import { Component } from '@angular/core';
import { RulevarService } from 'src/app/rule/rulevar.service';
import { RoutecrumpsService } from 'src/app/services/routecrumps.service'
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import { RuleService } from 'src/app/rule/rule-custom-service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { cdkOverlayRef } from 'src/app/shared/custom-overlay/cdk-overlay-ref';
import { EditIntelListComponent } from './edit-intel-list/edit-intel-list.component';
import { CdkOverlyayService } from 'src/app/shared/custom-overlay/cdk-overlyay.service';
import { TemplateDropdownComponent } from 'src/app/shared/custom-overlay/template-dropdown/template-dropdown.component';
import { ToastService } from 'src/app/shared/custom-overlay/toast/toast.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-view-intel-list',
  templateUrl: './view-intel-list.component.html',
  styleUrls: ['./view-intel-list.component.scss']
})

export class ViewIntelListComponent {
  constructor(
  public rulevarservice: RulevarService,
  private rcrumpService: RoutecrumpsService,
  private ruleservice: RuleService,
  public matdialog: MatDialog,
  private cdkverlayDialog: CdkOverlyayService,
  private toasterService: ToastService,
  private router:Router){}

  keyList=[]
  mat_spinner_List_state:boolean=false
  destroy$: Subject<boolean> = new Subject()
  removeControl$: Subject<boolean> = new Subject()
  selectAll = new FormControl()
  selected = new FormGroup({})
  selectedForDelete:boolean=false
  overLayRef: cdkOverlayRef;
  createrule: cdkOverlayRef;
  showReset:boolean=false
  editDialog:MatDialogRef<any>

  ngOnInit() {
    this.providerouteCrummp()
    this.getIntelList()
  }

  async getIntelList(){ // get list rows from api

    let reqObj={"list_name":this.rulevarservice.viewIntel.list_name,"list_id":this.rulevarservice.viewIntel.list_id}
    this.mat_spinner_List_state=true

    if(this.rulevarservice.intel_view){
      this.rulevarservice.intel_view_copy=JSON.parse(JSON.stringify(this.rulevarservice.intel_view?.field_values))
      this.rulevarservice.intel_view_copy=this.addIndexAsKey(this.rulevarservice.intel_view_copy)
      this.keyList=this.getSearchKeys(this.rulevarservice.intel_view_copy)
      this.search('')
      this.buildControl(this.rulevarservice.intel_view_copy)
      this.handleintelpagination()
    }else{
      await this.ruleservice.provideintellistview.postrequest(reqObj) .pipe(takeUntil(this.destroy$))
      .subscribe((dat: any) => {
        if(dat.field_values.length){
          this.rulevarservice.intel_view = dat
          this.rulevarservice.intel_view_copy=JSON.parse(JSON.stringify(this.rulevarservice.intel_view?.field_values))
          this.rulevarservice.intel_view_copy=this.addIndexAsKey(this.rulevarservice.intel_view_copy)
          this.keyList=this.getSearchKeys(this.rulevarservice.intel_view_copy)
          this.search('')
          this.buildControl(this.rulevarservice.intel_view_copy)
          this.handleintelpagination()
        }
        else{
          this.rulevarservice.intel_view_filtered=[]
          this.mat_spinner_List_state=false
        }
      }, (err) => {
              this.mat_spinner_List_state = false;
              this.rulevarservice.intelViewpagelength = 1;
              this.rulevarservice.intelViewpagenumber = 1;
          })
      
    }
  }

  ngAfterViewInit(){

    this.selectAll.valueChanges.pipe(distinctUntilChanged(),takeUntil(this.destroy$)).subscribe(dat=>{
      if(dat){
        Object.keys(this.selected.controls).forEach(form=>{
          this.selected.get(form).setValue(true)
        })
      }else{
        Object.keys(this.selected.controls).forEach(form=>{
          this.selected.get(form).setValue(false)
        })
      }
    })

    this.rulevarservice.intelviewsearch.valueChanges.pipe(takeUntil(this.destroy$),debounceTime(300)).subscribe(str=>{
      this.search(str)
      this.handleintelpagination()
    })

    this.rulevarservice.intelViewitemperpage.valueChanges.pipe(distinctUntilChanged()).subscribe((dat) => {// for rules repo
      this.mat_spinner_List_state = true;
      this.rulevarservice.intelViewitemperpage.setValue(dat, { emitEvent: false });
      this.handleintelpagination();
        this.mat_spinner_List_state = false;
    })

    this.selected.valueChanges.pipe(distinctUntilChanged(),takeUntil(this.destroy$)).subscribe(data=>{
      
    })
  }

  openSourceMenu_click(template: any, origin: any) {
    let config = {
      data: {
        "template": template,
      }
    }
    this.createrule=this.cdkverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
  }
  intelOptionClick(option,data){
    this.createrule.close()
    if(option.value === 'edit'){
      this.editRow(data)
    }else if(option.value === 'delete'){
      this.deleteRow(data)
    }
  }

  deleteRow(data){
    this.rulevarservice.viewIntelDeleteList.push(data)
    this.deleteClick()
  }

  editRow(data){
    this.editDialog=this.openOverlay(data)
    // console.log(this.editDialog)
    this.editDialog.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(data=>{
      if(this.rulevarservice.viewIntelEditList.length){
        this.showReset=true
      }else{
        this.showReset=false
      }
    })
  }

  openOverlay(data) {
    const dialogRef = this.matdialog.open(EditIntelListComponent, {
      width: "auto", height: "auto",data:data,  autoFocus: false,
      disableClose: false
    })

 
    return dialogRef;
  }

  buildControl(list){ // build formcontrol for checkbox
    list.forEach(data=>{
      this.selected.addControl(data.uniqueKey,new FormControl(false),{emitEvent:false})
      this.selected.get(data.uniqueKey.toString()).valueChanges.pipe(distinctUntilChanged(),takeUntil(this.removeControl$)).subscribe(val=>{
        this.uniqueKeyValChanges(val,data.uniqueKey,this.selected.get(data.uniqueKey.toString()))
      })
    })
  }

  uniqueKeyValChanges(data,key,control){ // formcontrol value changes
    let selectAll=true
    let selected=false
    Object.keys(this.selected.controls).forEach(val=>{
      if(!this.selected.get(val.toString()).value){
        selectAll=false
      }else{
        selected=true
      }
    })
    if(selectAll){
      this.selectAll.setValue(true,{emitEvent:false})
    }else{
      this.selectAll.setValue(false,{emitEvent:false})
    }
    this.selectedForDelete=selected

    if(data){
      let deleteIndex = this.rulevarservice.intel_view_copy.findIndex(val=> val.uniqueKey === key)
      if(deleteIndex !=-1 && deleteIndex != null){
        this.rulevarservice.viewIntelDeleteList.push(this.rulevarservice.intel_view_copy[deleteIndex])
      }
    }else{
      let putbackIndex = this.rulevarservice.viewIntelDeleteList.findIndex(val=>val.uniqueKey === key)
      if(putbackIndex!=-1 && putbackIndex != null){
        this.rulevarservice.viewIntelDeleteList.splice(putbackIndex,1)
      }
    }
  }

  deleteClick(){ // delete selected
    if(this.rulevarservice.viewIntelDeleteList.length ){
        this.rulevarservice.viewIntelDeleteList.forEach(row=>{
          let key = row.uniqueKey
          let  index = this.rulevarservice.intel_view_copy.findIndex(val=> val.uniqueKey === key)
          if(index != -1 && index != null){
            this.rulevarservice.intel_view_copy.splice(index,1)
          }
          if(this.rulevarservice.viewIntelEditList.length){
            let editIndex = this.rulevarservice.viewIntelEditList.findIndex(val=> val.new.uniqueKey === key)
            if(editIndex != -1 && editIndex != null){
              this.rulevarservice.viewIntelEditList.splice(editIndex,1)
            }
          }
        })
      
      this.rulevarservice.intelviewsearch.setValue('',{emitEvent:true})
    }
    this.selectedForDelete=false
    this.showReset=true
  }
  

  addIndexAsKey(list){ // add index as key to the list
    list.forEach((row,i)=>{
      row["uniqueKey"]=i
    })
    return list
  }

  getSearchKeys(list){ // get keys for search
    let keyList=[]
    Object.keys(list[0]).forEach(key=>{
      if(key != 'uniqueKey'){
        this.rulevarservice.intel_view.fields.forEach(val=>{
          if(key === val.fieldName){
            let obj={}
            obj["value"]=key
            obj["type"]=val.dataType
            keyList.push(obj)
          }
        })
      }else{
        let obj={}
        obj["value"]=key
        obj["type"]="number"
        keyList.push(obj)
      }
     
    })
    return keyList
  }

  
  
  providerouteCrummp() { // crumps
    this.rcrumpService.route_crumps[2] = {
      disp_str: this.rulevarservice.viewIntel.list_name,
      routeTo: "/intel-list/view-intel-list",
      callback: null,
      isParent: false
    }
    this.rcrumpService.route_crumps.length = 3;
  }

  refreshtable(){ // refresh table
    this.selectAll.setValue(false,{emitEvent:false})
    this.removeControl$.next(true)
    this.getIntelList()
    this.resetDefault()
    this.showReset=false
  }

  removeControl(){ // reset form controls
    this.selected.reset(),{emitEvent:false}
    this.selectAll.reset(),{emitEvent:false}
  }

  handleintelpagination() { // handle pagination
    const pagelength =
      Math.ceil(this.rulevarservice.intel_view_filtered.length / this.rulevarservice.intelViewitemperpage.getRawValue());
      // console.log({pagelength})
    if (pagelength) {
      this.rulevarservice.intelViewpagelength = pagelength;
    } else {
      this.rulevarservice.intelViewpagelength = 1;
    }
    if (
      (this.rulevarservice.intelViewpagenumber > this.rulevarservice.intelViewpagelength)
    ) {
      this.rulevarservice.intelViewpagenumber = this.rulevarservice.intelViewpagelength;
    }
  }


  paginationClick(direction: number){ // For Intel List
    if (!this.mat_spinner_List_state) {
      let pagevalue = this.rulevarservice.intelViewpagenumber;
      if (direction == -1) {
        if (pagevalue > 1) {
          this.rulevarservice.intelViewpagenumber = this.rulevarservice.intelViewpagenumber - 1;
        }
      } else {
        if (pagevalue < this.rulevarservice.intelViewpagelength) {
          this.rulevarservice.intelViewpagenumber = this.rulevarservice.intelViewpagenumber + 1;
        }
      }
    }
  }

  search(searchStr){ // search the table
    let filtered=[]
    filtered = this.rulevarservice.intel_view_copy.filter((rule: any) => {
      for(let i=0;i<= this.keyList.length-1;i++){
        if(this.keyList[i].type ==='text'){
          if(rule[this.keyList[i].value]?.toLowerCase().includes(searchStr.toLowerCase()) ){
            return rule
          }
        }else{
          if(rule[this.keyList[i].value].toString().includes(searchStr.toLowerCase()) ){
            return rule
          }
        }
      }
    })
    this.rulevarservice.intel_view_filtered=filtered
    this.mat_spinner_List_state=false
  }
  resetDefault(){ //reset all
    this.removeControl()
    this.rulevarservice.viewIntelDeleteList=[]
    this.rulevarservice.viewIntelEditList=[]
    this.rulevarservice.intelviewsearch.setValue('',{emitEvent:false})
  }
  deleteAllControls(){ // remove all controls
    Object.keys(this.selected.controls).forEach(key=>{
      this.selected.removeControl(key.toString(),{emitEvent:false})
    })
  }

  open_toaster(msg: string, type: any) {
    this.toasterService.show({
      text: msg,
      type: type
    })
  }

  async submitClick(){

    this.mat_spinner_List_state=true

    let updateList=[]
    if(this.rulevarservice.viewIntelEditList){
      updateList=JSON.parse(JSON.stringify(this.rulevarservice.viewIntelEditList))
    }

    let deleteList=[]

    if(this.rulevarservice.viewIntelDeleteList){
      deleteList=JSON.parse(JSON.stringify(this.rulevarservice.viewIntelDeleteList))
    }

    deleteList.forEach(row=>{
      delete row.uniqueKey
    })
    updateList.forEach(row=>{
      delete row.old.uniqueKey
      delete row.new.uniqueKey
    })

    let postvalue={"list_name":this.rulevarservice.viewIntel.list_name,"list_id":this.rulevarservice.viewIntel.list_id}
    postvalue["update"]=updateList
    postvalue["delete"]=deleteList

   
    // console.log(postvalue)

    await this.ruleservice.postIntelListValues.postrequest(postvalue)
    .then((dat: any) => {
//console.log({dat})
      this.open_toaster('Saved changes successfully', 'success');
      this.mat_spinner_List_state=false
      this.cancelClick()

    }).catch(err => {
      this.mat_spinner_List_state=false
        this.open_toaster('Failed to save changes', 'failure')
        this.cancelClick()
      })
  }

  cancelClick(){
    this.router.navigateByUrl('intel-list')
  }

  ngOnDestroy(){
    this.resetDefault()
    this.deleteAllControls()
    this.rulevarservice.intel_view=null
    this.rulevarservice.intel_view_copy=null
    this.rulevarservice.intel_view_filtered=null
    this.rulevarservice.intelViewpagelength=1
    this.rulevarservice.intelViewpagenumber=1
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.removeControl$.next(true);
    this.removeControl$.unsubscribe();
  }
}
